var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-container",
    { staticClass: "bv-example-row" },
    [
      _c("Header"),
      _vm._v(" "),
      _c(
        "b-row",
        [_c("b-col", { staticClass: "hr", attrs: { cols: "12" } })],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c("b-col", { attrs: { cols: "3" } }, [_c("Menu")], 1),
          _vm._v(" "),
          _c(
            "b-col",
            { staticClass: "border", attrs: { cols: "9" } },
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { staticClass: "head", attrs: { cols: "12" } },
                            [_c("h4", [_vm._v(":: Modelos")])]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            {
                              staticClass: "breadcrumb",
                              attrs: { cols: "12" }
                            },
                            [
                              _c(
                                "b-link",
                                {
                                  attrs: { to: { name: "ModelsListByBrand" } }
                                },
                                [_vm._v("Modelos por marca")]
                              ),
                              _vm._v(" » "),
                              _c(
                                "b-link",
                                {
                                  attrs: {
                                    href:
                                      "/models-by-brand/brand/" +
                                      this.$route.params.slug
                                  }
                                },
                                [
                                  _vm._v(
                                    "Lista de Oficinas de " +
                                      _vm._s(this.model.brand)
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "mt-2" }),
                      _vm._v(" "),
                      _c(
                        "b-form",
                        { on: { submit: _vm.onSubmit } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                id: "fieldsetHorizontal",
                                horizontal: "",
                                "label-cols": 4,
                                breakpoint: "md",
                                label: "Nombre del Modelo"
                              }
                            },
                            [
                              _c("b-form-input", {
                                attrs: { id: "name", state: _vm.state },
                                model: {
                                  value: _vm.model.name,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.model,
                                      "name",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "model.name"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                id: "fieldsetHorizontal",
                                horizontal: "",
                                "label-cols": 4,
                                breakpoint: "md",
                                label: "URL Imagen"
                              }
                            },
                            [
                              _c("b-form-input", {
                                attrs: { id: "name", state: _vm.state },
                                model: {
                                  value: _vm.model.image,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.model,
                                      "image",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "model.image"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(
                            "\n                // eslint-disable-next-line\n                "
                          ),
                          _c(
                            "b-button",
                            {
                              attrs: {
                                type: "submit",
                                variant: "primary derco"
                              }
                            },
                            [_vm._v("Guardar")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2313570d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2313570d","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CreateModel.vue
// module id = null
// module chunks = 